<template>
  <div class="wrapper">
    <div class="shop-container">
      <div class="nav">
        <router-link to="/">首页</router-link>
        <span>></span>
        <span>问卷调研</span>
      </div>

      <div class="main bgw" v-loading="loading">
        <template v-if="survey">
          <div class="top-head">
            {{ survey.title }}
            <div class="info" v-if="survey.description">
              <span>{{ survey.description }}</span>
            </div>
          </div>

          <div class="survey-content">
            <div class="group-box" v-for="(group, gIndex) in groups" :key="'g'+group.id">
              <!-- 只有大于1个分组时显示分组名称 -->
              <h2 class="group-title" v-if="groups.length > 1">{{ group.name }}</h2>

              <div class="item-block" v-for="(question, qIndex) in group.questions" :key="'q'+question.id">
                <div class="item-tit">
                  {{ getQuestionNumber(gIndex, qIndex) }}. {{ question.title }} 
                  <span v-if="question.is_required" class="required">*</span>
                </div>

                <!-- Radio -->
                <div v-if="question.type === 1" class="check-group">
                  <el-radio-group v-model="answers[question.id]">
                    <el-radio v-for="(opt, oIdx) in question.options" :key="oIdx" :label="opt">{{ opt }}</el-radio>
                  </el-radio-group>
                </div>

                <!-- Checkbox -->
                <div v-if="question.type === 2" class="check-group">
                  <el-checkbox-group v-model="answers[question.id]">
                    <el-checkbox v-for="(opt, oIdx) in question.options" :key="oIdx" :label="opt">{{ opt }}</el-checkbox>
                  </el-checkbox-group>
                </div>

                <!-- Textarea -->
                <div v-if="question.type === 3">
                  <el-input type="textarea" :rows="4" v-model="answers[question.id]" placeholder="请输入内容"></el-input>
                </div>

                <!-- Input -->
                <div v-if="question.type === 4">
                  <el-input v-model="answers[question.id]" placeholder="请输入内容"></el-input>
                </div>

                <!-- Select -->
                <div v-if="question.type === 5">
                  <el-select v-model="answers[question.id]" placeholder="请选择" style="width: 100%">
                    <el-option v-for="(opt, oIdx) in question.options" :key="oIdx" :label="opt" :value="opt"></el-option>
                  </el-select>
                </div>

                <div class="tip" v-show="errors[question.id]">请填写/选择此项</div>
              </div>
            </div>

            <div class="submit-action">
              <el-button 
                type="primary" 
                class="submit-btn" 
                :style="survey.button_color ? { backgroundColor: survey.button_color, borderColor: survey.button_color } : {}"
                :loading="submitting" 
                @click="submit" 
                :disabled="submitting"
              >
                {{ submitting ? '提交中...' : (survey.button_name || '提交') }}
              </el-button>
              <el-button
                v-if="pendingReward"
                type="danger"
                class="claim-prize-btn"
                @click="showRewardPopup"
              >
                领取奖品
              </el-button>
            </div>
          </div>
        </template>
        
        <template v-else-if="!loading">
          <div class="empty-status">问卷不存在或已结束</div>
        </template>

        <!-- 领奖弹窗 -->
        <el-dialog title="领取奖品" :visible.sync="rewardPopupVisible" width="600px">
          <div style="padding: 0 20px;">
            <div v-if="pendingReward && pendingReward.goods_name" style="font-size: 18px; color: #ff7159; margin-bottom: 20px; text-align: left;padding-top: 10px;">
              奖品：{{ pendingReward.goods_name }}
            </div>
            <div style="font-size: 15px; margin-bottom: 10px; font-weight: 500; color: #333;">请选择收货地址</div>
            <div class="address-list" v-if="addressList.length > 0">
              <div 
                class="address-item" 
                v-for="addr in addressList" 
                :key="addr.id" 
                :class="{'active': addressId === addr.id}"
                @click="selectAddress(addr.id)"
              >
                <div class="addr-info">
                  <div class="addr-name">{{ addr.name }} {{ addr.mobile }}</div>
                  <div class="addr-detail">{{ addr.area_name }} {{ addr.address }}</div>
                </div>
                <div class="addr-check" v-if="addressId === addr.id">
                  <i class="el-icon-check"></i>
                </div>
              </div>
              <div style="text-align: right; margin-top: 10px;">
                <el-button type="text" @click="dialogAddressShow = true">新增收货地址</el-button>
              </div>
            </div>
            <div class="empty-address" v-else>
              暂无收货地址
              <el-button type="text" @click="dialogAddressShow = true">去添加收货地址</el-button>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="rewardPopupVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmClaim" :loading="claiming">确认领取</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    
    <!-- 地址添加/修改弹窗 -->
    <SelectAddress
      :dialogAdressVisible="dialogAddressShow"
      @hideDialog="hideAddressDialog"
      :data="modifyData"
      :type="addressDialogType"
    ></SelectAddress>
  </div>
</template>

<script>
import { getSurveyDetail, submitSurvey, deliverGoods } from '../http.js';
import { post } from '@/config/http.js';
import SelectAddress from "@/components/address/index";

export default {
  name: 'Survey',
  components: { SelectAddress },
  data() {
    return {
      loading: true,
      submitting: false,
      survey: null,
      groups: [],
      answers: {},
      errors: {},
      pendingReward: null,
      rewardPopupVisible: false,
      addressList: [],
      addressId: 0,
      claiming: false,
      dialogAddressShow: false,
      modifyData: {},
      addressDialogType: 0
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let id = this.$route.params.id;
      getSurveyDetail({ id: id }).then(res => {
        this.loading = false;
        if (res.status && res.data) {
          this.survey = res.data.survey;
          this.groups = res.data.groups || [];
          let userAnswers = res.data.user_answers || {};
          this.initAnswers(userAnswers);
          
          if (res.data.pending_reward) {
              this.pendingReward = res.data.pending_reward;
          }
        } else {
          this.$message.error(res.msg || '获取问卷失败');
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    initAnswers(userAnswers) {
      this.groups.forEach(group => {
        if (group.questions) {
          group.questions.forEach(q => {
            if (userAnswers.hasOwnProperty(q.id)) {
              this.$set(this.answers, q.id, userAnswers[q.id]);
            } else {
              // Checkbox needs array
              if (q.type === 2) {
                this.$set(this.answers, q.id, []);
              } else {
                this.$set(this.answers, q.id, '');
              }
            }
            this.$set(this.errors, q.id, false);
          });
        }
      });
    },
    getQuestionNumber(gIndex, qIndex) {
      // 连续编号
      let num = 0;
      for (let i = 0; i < gIndex; i++) {
        num += this.groups[i].questions.length;
      }
      return num + qIndex + 1;
    },
    validate() {
      let valid = true;
      this.groups.forEach(group => {
        if (group.questions) {
          group.questions.forEach(q => {
            this.errors[q.id] = false;
            if (q.is_required) {
              let ans = this.answers[q.id];
              if (q.type === 2 && (!ans || ans.length === 0)) {
                this.errors[q.id] = true;
                valid = false;
              } else if (ans === '' || ans === null || ans === undefined) {
                this.errors[q.id] = true;
                valid = false;
              }
            }
          });
        }
      });
      return valid;
    },
    submit() {
      if (!this.validate()) {
        this.$message.error('请完善必填信息');
        return;
      }

      let token = this.$storage.get("userToken");
      if (!token) {
        this.$message.error('请先登录');
        this.$router.push('/login');
        return;
      }

      let postData = {
        id: this.survey.id,
        answers: [],
        token: token
      };

      for (let qId in this.answers) {
        postData.answers.push({
          question_id: qId,
          answer: this.answers[qId]
        });
      }

      this.submitting = true;
      submitSurvey(postData).then(res => {
        this.submitting = false;
        if (res.status) {
          if (res.data && res.data.reward_type === 2 && res.data.log_id) {
              this.pendingReward = { id: res.data.log_id, goods_name: res.data.goods_name };
          }
          
          // Set never pop up again flag
          let neverKey = `survey_popup_never_${this.survey.id}`;
          this.$storage.set(neverKey, true);

          if (this.pendingReward) {
            this.$alert(res.msg || '提交成功！您有一份商品奖品需要填写收货地址进行领取。', '提示', {
              confirmButtonText: '去领奖',
              callback: action => {
                if (action === 'confirm') {
                  this.showRewardPopup();
                }
              }
            });
          } else {
            this.$alert(res.msg || '提交成功', '提示', {
              confirmButtonText: '确定'
            });
          }
        } else {
          this.$message.error(res.msg || '提交失败');
        }
      }).catch(err => {
        this.submitting = false;
        this.$message.error('请求失败');
      });
    },
    fetchAddressList(newAddrId = null) {
      let token = this.$storage.get("userToken");
      if (!token) return;
      post('user.getusership', { token: token }).then(res => {
        if (res.status) {
          this.addressList = res.data;
          if (newAddrId && typeof newAddrId === 'number') {
            this.addressId = newAddrId;
          }
        }
      });
    },
    hideAddressDialog(newAddrId) {
      this.dialogAddressShow = false;
      if (newAddrId) {
        this.fetchAddressList(newAddrId);
      }
    },
    showRewardPopup() {
      let token = this.$storage.get("userToken");
      if (!token) {
        this.$message.error('请先登录');
        return;
      }
      post('user.getusership', { token: token }).then(res => {
        if (res.status) {
          this.addressList = res.data;
          this.rewardPopupVisible = true;
        } else {
          this.$message.error(res.msg || '获取地址失败');
        }
      });
    },
    selectAddress(id) {
      this.addressId = id;
    },
    confirmClaim() {
      if (!this.addressId) {
        this.$message.error('请选择收货地址');
        return;
      }
      this.claiming = true;
      deliverGoods({ log_id: this.pendingReward.id, address_id: this.addressId }).then(res => {
        this.claiming = false;
        if (res.status) {
          this.$message.success(res.msg || '领奖信息已提交，请等待奖品派发');
          this.pendingReward = null;
          this.rewardPopupVisible = false;
        } else {
          this.$message.error(res.msg || '领取失败');
        }
      }).catch(() => {
        this.claiming = false;
        this.$message.error('请求失败');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';

.wrapper {
  background: $theme-bg;
  padding-bottom: 40px;
}
.nav {
  @include line-height(40px);
  font-size: 12px;
  span {
    padding: 0 4px;
    color: #757575;
  }
  a:hover {
    color: #000;
  }
}
.bgw {
  background-color: #fff;
}
.main {
  padding: 30px 40px 60px;
  min-height: 600px;
}

.top-head {
  font-size: 26px;
  font-weight: 500;
  line-height: 40px;
  color: #333;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  text-align: center;
  
  .info {
    font-size: 14px;
    color: #76838f;
    margin-top: 8px;
    line-height: 1.6;
  }
}

.survey-content {
  max-width: 800px;
  margin: 0 auto;
}

.group-title {
  font-size: 18px;
  color: #333;
  margin: 30px 0 20px;
  padding-left: 10px;
  border-left: 4px solid $theme-color;
  font-weight: bold;
}

.item-block {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #eee;
}
.item-block:last-child {
  border-bottom: none;
}

.item-tit {
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 500;
  line-height: 1.5;
  
  .required {
    color: #f56c6c;
    margin-left: 4px;
    font-weight: bold;
  }
}

.check-group {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-radio, 
::v-deep .el-checkbox {
  display: inline-flex;
  align-items: center;
  margin-bottom: 15px;
  margin-right: 30px;
  margin-left: 0 !important;
}
::v-deep .el-radio__label, 
::v-deep .el-checkbox__label {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  white-space: normal;
  display: inline-block;
  vertical-align: middle;
}
::v-deep .el-radio__inner, 
::v-deep .el-checkbox__inner {
  width: 16px;
  height: 16px;
}

.tip {
  color: #f56c6c;
  font-size: 13px;
  margin-top: 8px;
  display: flex;
  align-items: center;
}
.tip::before {
  content: "!";
  display: inline-block;
  width: 14px;
  height: 14px;
  background: #f56c6c;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 14px;
  font-size: 12px;
  margin-right: 6px;
}

.submit-action {
  margin-top: 40px;
  text-align: center;
}
.submit-btn {
  width: 200px;
  height: 44px;
  font-size: 16px;
  transition: all 0.3s;
}
.submit-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.claim-prize-btn {
  width: 200px;
  height: 44px;
  font-size: 16px;
  transition: all 0.3s;
  margin-left: 20px;
}
.claim-prize-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.address-list {
  max-height: 400px;
  overflow-y: auto;
}
.address-item {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 6px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.address-item:hover {
  border-color: #ffd2cb;
}
.address-item.active {
  border-color: #ff7159;
  background-color: #fffaf9;
}
.addr-info {
  flex: 1;
}
.addr-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}
.addr-detail {
  font-size: 13px;
  color: #666;
}
.addr-check {
  color: #ff7159;
  font-size: 20px;
  font-weight: bold;
  margin-left: 15px;
}
.empty-address {
  padding: 40px 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}
</style>
